module.exports = __webpack_public_path__ + "img/edit-icon.aa7d52de.svg";